import snsWebSdk from '@sumsub/websdk';
window.snsWebSdk = snsWebSdk;